"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Abstrakter Geocoder.
 *
 * @abstract
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.module.GCLocator
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen.
 * @param {gc.gis.module.GCLocator} options.module Modul-Instanz
 * @param {Array<Object>} options.controls Liste von Controls
 * @param {string} options.id ID
 * @param {string} options.label Label
 * @param {string} options.url URL zum Webservice
 * @param {string} options.type Geocoder-Typ
 * @param {gc.gis.module.GCLocatorGroup} options.group zugehörige Gruppe
 * @param {gc.gis.map.GCMapView} options.map Karte, auf der die Ergebnisse angezeigt werden
 * @param {string} [options.crs=null] Koordinatenreferenzsystem, des Webservices
 * @param {number} [options.autocompleteLength=0] Ab wie vielen Zeichen ist autocomplete aktiv?
 * @param {number} [options.autocompleteDelay=500] Zeit, die zwischen Tastendruck und autocomplete vergeht
 * @param {gc.gis.format} [options.outputFormat={@link gc.gis.format.WKT}]
 */
gc.gis.module.GCLocator.AbstractGeocoder = function( options )
{
	gc.gis.assert.isSet( options );
	gc.gis.assert.isSet( options.controls );

	gc.gis.widget.GCWidget.call( this, options );

	this.module              = options.module;
	this.id                  = options.id;
	this.type                = options.type;
	this.group               = options.group;
	this.label               = options.label;
	this.crs                 = options.crs || null;
	this.autocomplete_length = options.autocompleteLength || 0;
	this.autocomplete_delay  = options.autocompleteDelay || 500;
	this.controls            = options.controls;
	this.url                 = options.url;
	this.map                 = options.map;
	this.output_format       = options.outputFormat || gc.gis.format.WKT;
};
gc.gis.module.GCLocator.AbstractGeocoder.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @abstract
 * @protected
 * @method
 *
 * @param {gc.gis.module.GCLocator.AbstractGeocoder} self this
 * @param {Object} control Control-Referenz
 * @param {Object} results Ergebnisliste
 * @param {boolean} [opt_show_list=true]
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._renderResultList = gc.gis.abstractMethod;

/**
 * @abstract
 * @protected
 * @method
 *
 * @param {Object} result_item Eintrag aus der Ergebnisliste
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._showOnMap = gc.gis.abstractMethod;

/**
 * @abstract
 * @protected
 * @method
 *
 * @param {number} index Index des zu validierenden Controls
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._validateControl = gc.gis.abstractMethod;

/**
 * @abstract
 * @protected
 * @method
 *
 * @param {gc.gis.module.GCLocator.AbstractGeocoder} self this
 * @param {number} control_index
 * @param {boolean} opt_detail_search
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._getQueryString = gc.gis.abstractMethod;

/**
 * @abstract
 * @protected
 * @method
 *
 * @param {Object} data
 * @return {Object}
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._parseGeocoderResults = gc.gis.abstractMethod;

/**
 * @protected
 * @method
 *
 * @param {gc.gis.module.GCLocator.AbstractGeocoder} self this
 * @param {number} control_index
 * @param {boolean} opt_detail_search
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._geocode = function( self, control_index, opt_detail_search )
{
	var control = this.controls[control_index];

	// Validieren
	var invalid = false;
	this.element.find('.control-input').parents('.form-group').removeClass('has-error');

	for( var i=0; i<=control_index; i++ )
	{
		try
		{
			var input = this.controls[i]._element_input;
			this._validateControl( input, i, control_index );
		}
		catch( err )
		{
			gc.gis.iface.log.error( this, err );
			this.controls[i]._element_input.parents('.form-group').addClass('has-error');
			invalid = true;
		}
	}
	if( invalid === true )
	{
		return;
	}

	// Ausführen
	var query = this._getQueryString( self, control_index, opt_detail_search );
	try
	{
		this.__performQuery(
			control,
			query,
			!opt_detail_search,
			!opt_detail_search
		);
	}
	catch( err )
	{
		gc.gis.iface.log.error( this, err );
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._render = function()
{
	// Container
	this.element = jQuery('<div>', {
		'class': 'gc-widget-panel gc-geocoder-instance'
	});

	// Geocoder-Instanzen
	for( var i=0; i<this.controls.length; i++ )
	{
		this.controls[i]['_cache'] = {};
		var element_control = this.__renderControl( i );
		this.element.append( element_control );
	}

	return this.element;
};

/**
 * @private
 * @method
 *
 * @param {number} index Index des zu rendernden Controls
 * @return {jQuery}
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype.__renderControl = function( index )
{
	var self = this;
	var config = this.controls[index];

	// Ergebnisliste
	var element_result_list = jQuery('<ul>', {
		'class': 'gc-geocoder-results dropdown-menu gc-scrollable-menu'
	});
	element_result_list.hide();
	config._element_list = element_result_list;

	// Input
	var element_input = jQuery('<input>', {
		'class': 'form-control control-input',
		type: 'text',
		name: config.param,
		placeholder: config.placeholder,
		focus: function( evt ) {
			if( element_result_list.children().length )
			{
				element_result_list.show('fade');
			}
			else if( jQuery(this).val().length >= self.autocomplete_length )
			{
				self._resetControls( index+1 );
				self._geocode( self, index );
			}
		},
		blur: function( evt ) {
			element_result_list.hide('fade');
		},
		click: function (evt) {
			element_input.select();
		}
	});
	element_input.attr('size', config.size);
	element_input.attr('autocomplete', 'off');
	config._element_input = element_input;

	var timer;
	element_input.on('keyup', function( evt ) {
		var key = evt.keyCode || evt.which;
		var val = jQuery(this).val();

		// tab, enter, shift, ctrl, alt, pause/break, caps, escape, page up/down, end, home, arrow keys
		if(val.length >= self.autocomplete_length
			&& (key < 9 || key > 40) || key === 13 )
		{
			// nachfolgende Controls resetten
			self._resetControls( index+1 );
			// identifier entfernen, damit wieder Liste geladen wird
			jQuery(this).removeData('identifier');

			// Timer resetten
			clearTimeout( timer );
			timer = setTimeout( function() {
				self._geocode( self, index );
			}, self.autocomplete_delay );
		}
	});

	// Label
	var element_label = jQuery('<label>', {
		//'class': 'form-group',
		html: '<span>'+ config.label +'</span> '
	});
	element_label.append( element_input );

	// Container
	var element_container = jQuery('<div>', {
		'class': 'form-group'
	});

	element_container.append( element_label ).append( element_result_list );

	return element_container;
};

/**
 * @protected
 * @method
 *
 * @param {number} start_at_index Index, ab dem resettet werden soll
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype._resetControls = function( start_at_index )
{
	for( var i=start_at_index; i<this.controls.length; i++ )
	{
		this.controls[i]._cache = {};
		this.controls[i]._element_input.val('');
		this.controls[i]._element_input.removeData('identifier');
		this.controls[i]._element_list.children().remove();
		this.controls[i]._element_input.parents('.form-group').removeClass('has-error');
	}
};

/**
 * @private
 * @method
 *
 * @param {Object} control Control-Referenz
 * @param {string} query Query-String
 * @param {boolean} use_cache Cache benutzen?
 * @param {boolean} [opt_show_list] Liste anzeigen?
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype.__performQuery = function( control, query, use_cache, opt_show_list )
{
	var self = this;
	//console.log('QUERY='+query);
	//console.log('USE_CACHE='+use_cache);

	var value = control._element_input.val();

	// Aus Cache holen
	if( use_cache && control._cache[value])
	{
		self._renderResultList( self, control, control._cache[value], false );
	}
	// Anfrage starten
	else
	{
		// Controls sperren
		for( var i=0; i<self.controls.length; i++ )
		{
			self.controls[i]._element_input.attr('disabled', true );
		}
		control._element_input.addClass('loading');

		// Query abfeuern
		gc.gis.iface.request.ajax({
			label: 'Verortung ... ',
			context: this,
			url: query,
			success: function(data)
			{
				try
				{
					self.__onGeocoderResults(self, data, control, opt_show_list);
				}
				catch (err)
				{
					if (err instanceof gc.gis.error.GCOutOfMaxExtentError)
					{
						gc.gis.iface.log.info(this, err.message);
					}
					else
					{
						gc.gis.iface.log.error(this, 'Bei der Abfrage des Verortungsdienstes trat ein Fehler auf.');
					}
				}
			},
			error: function()
			{
				gc.gis.iface.log.error(this, 'Bei der Abfrage des Verortungsdienstes trat ein Fehler auf.');
			},
            finally: function() {
                // Controls reaktivieren
                for( var i=0; i<self.controls.length; i++ )
                {
                    self.controls[i]._element_input.attr('disabled', false );
                }
                control._element_input.removeClass('loading');
                if (opt_show_list)
                {
	                control._element_input.focus();
                }
			}
		});
	}
};

/**
 * @private
 * @method
 *
 * @param {gc.gis.module.GCLocator.AbstractGeocoder} self this
 * @param {Object} data
 * @param {Object} control
 * @param {boolean} [opt_show_list]
 */
gc.gis.module.GCLocator.AbstractGeocoder.prototype.__onGeocoderResults = function( self, data, control, opt_show_list )
{
	var results = self._parseGeocoderResults(data);

	// Cache speichern
	var value = control._element_input.val();
	control._cache[value] = results;

	self._renderResultList( self, control, results, opt_show_list );

	// ggf. Geometrie highlighten (wird bei internen Suchdiensten genutzt, da dort die Geometrie über einen
	// Detail-Request erst beim Auswählen eines Eintrags aus der Liste passiert)
	if (results.length === 1 && results[0].geometry && results[0].geometry.wkt)
	{
		self._showOnMap(results[0]);
	}
};
